import dataSelect from '@store/dataForSelect/reducers';

import { course_select } from '../../configs/constants';

export default dataSelect(course_select);
